import { useChat } from '../../chat/ChatProvider';
import { canManagePins } from '../../chat/pinPermissions';

/**
 * 會話置頂列：點擊跳轉；有權限者可取消置頂。
 */
export default function PinnedMessagesBar({ conversationId }) {
  const { state, jumpToMessage, unpinMessage } = useChat();
  const cid = String(conversationId);
  const pins = state.pinsByConversation[cid] || [];
  const conv = state.conversations.find(
    (c) => String(c.conversationId || c.id) === cid
  );
  const manage = canManagePins(conv);

  if (!pins.length) return null;

  return (
    <div className="chat-pins-bar" role="region" aria-label="置頂訊息">
      <ul className="chat-pins-bar__list">
        {pins.map((pin) => (
          <li key={pin.serverMessageId} className="chat-pins-bar__item">
            <button
              type="button"
              className="chat-pins-bar__jump"
              onClick={() =>
                jumpToMessage(conversationId, {
                  serverMessageId: pin.serverMessageId,
                  seq: pin.seq,
                }).catch(() => {})
              }
            >
              <span className="chat-pins-bar__label">置頂</span>
              <span className="chat-pins-bar__text">
                {pin.previewText || pin.messageType || '訊息'}
              </span>
            </button>
            {manage ? (
              <button
                type="button"
                className="chat-link-btn chat-pins-bar__unpin"
                title="取消置頂"
                onClick={() =>
                  unpinMessage(conversationId, pin.serverMessageId).catch(() => {})
                }
              >
                取消
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
